import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";

// Import Bootstrap CSS and JS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const app = createApp(App);

app.use(router);

app.mount("#app");

// Initialize AOS
AOS.init({
  duration: 1000,
  easing: "ease-in-out",
  once: true,
  mirror: false,
});

// Signal the prerenderer (@prerenderer/renderer-puppeteer) that the app has
// finished its initial render so the route's HTML can be snapshotted at build
// time. No-op in the browser at runtime.
router.isReady().then(() => {
  document.dispatchEvent(new Event("render-event"));
});
